// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Committee } from './committee';
import { CommitteeAttachmentEmailLink } from './committee-attachment-email-link';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CommitteeAttachmentEmail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  body?: string;
  cc?: string;
  committeeId!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  sent?: Date;
  sentTo?: string;
  subject?: string;
  attachmentLinks!: CommitteeAttachmentEmailLink[];
  committee!: Committee;
}

